module.exports = __webpack_public_path__ + "img/han_jie_gong_zuo_zhan-icon0.1dfe37df.png";